// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__W+QHg","back":"styles_back__pguFu"};